import { createContext } from 'react';

export type CanRedirectToUrl = (params: {
  redirect: string;
  isUserAnonymous: boolean;
  isUserPrincipal: boolean;
  isUserAgent: boolean;
}) => boolean;

interface AuthRouteContextState {
  canRedirectToUrl: CanRedirectToUrl;
}

export const AuthRouteContext = createContext<AuthRouteContextState>({
  canRedirectToUrl: () => true,
});
